import { useMutation } from 'react-query';
import { RequestPasswordResetValues, requestPasswordReset } from '../../api';

export const useRequestPasswordReset = () => {
  return useMutation(
    (values: RequestPasswordResetValues) => requestPasswordReset(values),
    {},
  );
};
